import React, {ReactElement, createRef, RefObject, ReactNode} from 'react';
import {FilterMatchMode} from 'primereact/api';
import {Column, ColumnFilterElementTemplateOptions} from 'primereact/column';
import {Calendar} from 'primereact/calendar';
import MComponent from '../../Toolkit/Components/Component';
import WithRouterProps from '../../Toolkit/WithRouterProps';
import MPage, {MPageProps} from '../../Toolkit/Components/Shell/Page';
import MTable, {MTableFilters, MTableProps} from '../../Components/Toolkit/Table';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import MButton from '../../Toolkit/Components/Controls/Button';
import {MNewIconName, MSuccessIcon} from '../../Toolkit/Icons';
import {Request, RequestMultiReply, RequestReply} from '../../Api/ControllerTypes/RequestTypes';
import WithRouter from '../../Toolkit/WithRouter';
import {CreateRequestRequest, RequestClient} from '../../Api/RequestClients';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import NSwagAdapter from '../../Toolkit/Api/NSwagAdapter';
import MNSwagClientConfiguration from '../../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';
import MMultiDropDown from '../../Toolkit/Components/Controls/MultiDropDown';
import {MDropDownItem} from '../../Toolkit/Components/Controls/DropDownOption';
import {LockReply} from '../../Api/ControllerTypes/LockTypes';
import {CreateLockRequest, LockClient} from '../../Api/LockClient';
import MessageDialog from '../../Dialogs/MessageDialog';
import EnumContext from '../../Context/enum-context';
import {EnumerationClient} from '../../Api/EnumerationClient';
import {Enumeration, QuoteStatusReply} from '../../Api/ControllerTypes/EnumerationTypes';
import {DataTable, DataTableExportFunctionParams} from 'primereact/datatable';
import {ProjectClient} from '../../Api/ProjectClient';
import TrafficManagementAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';
import {Project, ProjectMultiReply} from '../../Api/ControllerTypes/ProjectTypes';

type SessionData = {
    first: number;
    rows: number;
    sortField: string;
    sortOrder: number;
    multiSortMeta: {
        field: string;
        order: number;
    },
    filters: MTableFilters;
    columWidths: number[];
}

type RequestRow = {
    data: Request;
    quoteStatus: string;
}

type Props = WithMsalProps & WithRouterProps & {};

/** */
type State = {
    page: MPageProps;
    table: MTableProps<RequestRow>;
    selectedRow?: RequestRow;
    completeCount: number;
    unactionedCount: number;
    inProgressCount: number;
    awaitingInfoCount: number;
    projectList: Project[];
}

const SessionDataTag: string = "RequestsTable";

class ListRequestsPage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private readonly m_requestClient: NSwagAdapter<RequestClient>;
    private readonly m_lockClient: NSwagAdapter<LockClient>;
    private readonly m_enumClient: NSwagAdapter<EnumerationClient>;
    private readonly m_projectClient: NSwagAdapter<ProjectClient>;
    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_messageDialogRef: RefObject<MessageDialog>;
    private readonly m_dataTableRef: RefObject<DataTable>;
    private m_interval: any = 0;
    private filterDefinition: MTableFilters | undefined;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_requestClient = new NSwagAdapter<RequestClient>(new RequestClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_lockClient = new NSwagAdapter<LockClient>(new LockClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_enumClient = new NSwagAdapter<EnumerationClient>(new EnumerationClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_projectClient = new NSwagAdapter<ProjectClient>(new ProjectClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_pageRef = createRef<MPage>();
        this.m_messageDialogRef = createRef<MessageDialog>();
        this.m_dataTableRef = createRef<DataTable>();

        this.initializeState();

    }

    private bindMethods(): void {

        this.isOpenButtonDisabled = this.isOpenButtonDisabled.bind(this);
        this.new_Click = this.new_Click.bind(this);
        this.archive_Click = this.archive_Click.bind(this);
        this.crews_Click = this.crews_Click.bind(this);
        this.dayView_Click = this.dayView_Click.bind(this);
        this.invoices_Click = this.invoices_Click.bind(this);
        this.drawings_Click = this.drawings_Click.bind(this);
        this.commercials_Click = this.commercials_Click.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.getToolbarTemplate = this.getToolbarTemplate.bind(this);
        this.getSlaFilterTemplate = this.getSlaFilterTemplate.bind(this);
        this.slaTypeTemplate = this.slaTypeTemplate.bind(this);
        this.getProjectFilterTemplate = this.getProjectFilterTemplate.bind(this);
        this.getWorkstreamFilterTemplate = this.getWorkstreamFilterTemplate.bind(this);
        this.getQuoteStatusFilterTemplate = this.getQuoteStatusFilterTemplate.bind(this);
        this.getJobStatusFilterTemplate = this.getJobStatusFilterTemplate.bind(this);
        this.exportDataClick = this.exportDataClick.bind(this);
        this.exportFunction = this.exportFunction.bind(this);
        this.isProjectsDisabled = this.isProjectsDisabled.bind(this);
    }

    /** */
    private initializeState(): void {

        //  Page
        const page: MPageProps = {
            locked: false
        };

        const userName = this.props.msalContext.accounts[0].name;
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const planningMember = roles?.includes('Planner') === true;
        //  Table
        const sessionString: string | null = localStorage.getItem(SessionDataTag)
        if(sessionString) {
            const sessionData: SessionData | null = JSON.parse(sessionString)
            sessionData!.filters['data.dueDate'].value = sessionData?.filters['data.dueDate'].value === null ? null : new Date(sessionData?.filters['data.dueDate'].value);
            sessionData!.filters['data.quoteCompleteDate'].value = sessionData?.filters['data.quoteCompleteDate'].value === null ? null : new Date(sessionData?.filters['data.quoteCompleteDate'].value);
            if(sessionData!.filters['data.submittedDate'] === undefined) {
                sessionData!.filters['data.submittedDate'] = {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                }
            } else {
                sessionData!.filters['data.submittedDate'].value = sessionData?.filters['data.submittedDate'].value === null ? null : new Date(sessionData?.filters['data.submittedDate'].value);
            }
            if(sessionData!.filters['data.createdOn'] !== undefined){
                delete sessionData!.filters['data.createdOn'];
                localStorage.clear();
            }
            this.filterDefinition = sessionData?.filters;
        } else {
            this.filterDefinition = {
                'data.estimate': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'data.requestor': {
                    value: planningMember ? userName : null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'data.slaType': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'data.projectValue': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'data.workStream': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'quoteStatus': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'data.county': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'data.postcode': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'data.submittedDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'data.dueDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'data.quoteCompleteDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                }
            }
        }

        const table: MTableProps<RequestRow> = {
            rowData: [],
            filters: this.filterDefinition
        };

        this.state = {
            page: page,
            table: table,
            selectedRow: undefined,
            completeCount: 0,
            unactionedCount: 0,
            inProgressCount: 0,
            awaitingInfoCount: 0,
            projectList: []
        };

    }

    public componentDidMount() : void {
        this.m_interval = setInterval(this.page_onLoadData, 300000);
    }

    public componentWillUnmount(): void {
        //this.m_dataTableRef.current?.saveState()
        clearInterval(this.m_interval);
    }

    private isOpenButtonDisabled(): boolean {
        return this.state.selectedRow === undefined;
    }

    private isProjectsDisabled(): boolean {
        const allowedRoles: string[] = ['Supervisor'];
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const access = allowedRoles.some(a => roles?.includes(a));

        return !access;
    }

    /** */
    private async new_Click(): Promise<void> {
        //Create new blank entry and pass to create page.
        const createRequest = new CreateRequestRequest({
            estimate: '',
            additionalRef: '',
            requestor: this.props.msalContext.accounts[0].name,
            exchange: '',
            slaType: -1,
            projectValue: -1,
            workStream: -1,
            workDescription: '',
            estimatedDays: 0,
            pedestrianManage: -1,
            address1: '',
            address2: undefined,
            address3: undefined,
            city: '',
            county: '',
            postcode: '',
            northing: 0,
            easting: 0,
            gridReference: undefined,
            parent: undefined
        });

        const result = await this.m_requestClient.callWithReply(RequestReply, (client => client.create(createRequest)));
        result.throwIfFailed();

        this.props.navigate(`/requests/create/${result.reply!.request!.id}`);
    }

    private archive_Click(): void {
        this.props.navigate(`/archive`);
    }

    private crews_Click(): void {
        this.props.navigate('/crews');
    }

    private dayView_Click(): void {
        this.props.navigate('/dayview');
    }

    private invoices_Click(): void {
        this.props.navigate('/invoices');
    }

    private drawings_Click(): void {
        this.props.navigate('/drawings');
    }

    private commercials_Click(): void {
        this.props.navigate('/commercials');
    }

    private async table_onSelectionChange(selection: RequestRow | RequestRow[] | undefined): Promise<void> {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as RequestRow | undefined);

        const navigateTo = selection as RequestRow | undefined

        if(navigateTo !== undefined) {
            const userName = this.props.msalContext.accounts[0].username;

            const lockResult = await this.m_lockClient.callWithReply(
                LockReply, (client) => client.get(navigateTo!.data.id)
            );
            lockResult.throwIfFailed();
            if(lockResult.reply!.lockData!.isLocked && lockResult.reply!.lockData!.lockingUser !== userName){
                this.m_messageDialogRef.current!.show(
                    'Request in use',
                    `Request ${navigateTo.data.estimate} is currently in use by '${lockResult.reply!.lockData!.lockingUser}'`,
                    MSuccessIcon);
            }
            else{
                await this.m_lockClient.call(
                    (client) => client.create(new CreateLockRequest(
                        {
                            itemId: navigateTo.data.id
                        })
                    ));
                this.props.navigate(`/requests/${navigateTo!.data.id}`);
            }
        }

    }

    private async page_onLoadData(): Promise<void> {
        let quoteStates: Enumeration[];
        if(this.context.enums === undefined || this.context.enums === null) {
            const quoteResult = await this.m_enumClient.callWithReply(
                QuoteStatusReply, (client) => client.getQuotationStatus(''));
            quoteResult.throwIfFailed();
            quoteStates = quoteResult.reply!.quoteStatuses;
        } else {
            quoteStates = this.context.enums!.quoteStatuses;
        }

        //Get Row Data
        const listResult = await this.m_requestClient.callWithReply(
            RequestMultiReply, (client) => client.getRequestList());
        listResult.throwIfFailed();

        const projectResult = await this.m_projectClient.callWithReply(ProjectMultiReply, (client) => client.getAll());
        projectResult.throwIfFailed();

        this.safeSetState((draft: State) => {
            draft.table.rowData = listResult.reply!.requests.map((w: Request) => {
                const index = quoteStates.findIndex(value => value.id === w.quoteStatus);
                let quoteStatus = (index !== undefined && index !== -1)
                                    ? quoteStates[index!].name!
                                    : '';
                quoteStatus += w.quoteStatus === 6 ? w.quoteSubName : '';
                quoteStatus += w.quoteStatus === 1 ? ` - ${w.quoteTechnician}` : '';
                return {data: w, quoteStatus: quoteStatus} as RequestRow;
            });
            draft.completeCount = listResult.reply!.requests.filter(r => r.quoteStatus === 3 || r.quoteStatus === 4).length;
            draft.unactionedCount = listResult.reply!.requests.filter(r => r.quoteStatus === 0).length;
            draft.inProgressCount =  listResult.reply!.requests.filter(r => r.quoteStatus === 1 || r.quoteStatus === 6).length;
            draft.awaitingInfoCount = listResult.reply!.requests.filter(r => r.quoteStatus === 2).length;
            draft.projectList = projectResult.reply!.projects;
        });
    }

    private exportFunction(e : DataTableExportFunctionParams){
        if(e.field === "data.projectValue") {
            const index = this.state.projectList.findIndex(value => value.id === e.data);
            if(index === undefined || index === -1) {
                return null;
            }
            return `${this.state.projectList[index].code} - ${ this.state.projectList[index].name}`;
        }
        if(e.field === "data.workStream")
            return this.context.enums!.workStreams[e.data]?.name ?? '';
        if(e.field === "data.slaType")
            return this.context.enums?.slaTypes[e.data]?.name ?? '';
        if(e.field === "data.drawingsBy")
            return e.data !== null && e.data.length > 0
                             ? e.data.join(', ')
                             : '';
        if(e.field === "data.dueDate" || e.field === "data.quoteCompleteDate" || e.field === 'data.submittedDate')
            return new Intl.DateTimeFormat('en-GB').format(e.data);
        return e.data
    }

    private exportDataClick() {
        this.m_dataTableRef.current!.exportCSV({selectionOnly: false});
    }

    private getToolbarTemplate(): ReactElement<MToolbar> {
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const planningMember = roles?.includes('Planner') === true;
        const supervisor = roles?.includes('Supervisor') === true;

        return (
            <MToolbar>
                <MButton label="Add"
                         color="success"
                         icon={MNewIconName}
                         iconOnly={false}
                         disabled={false}
                         onClick={this.new_Click}/>
                <MSpacer/>
                <MButton label={"Export Data"}
                         icon={"pi pi-file-export"}
                         color="success"
                         disabled={false}
                         onClick={this.exportDataClick}
                />
                <MSpacer/>
                <MButton label="Archive"
                         color={"info"}
                         icon={"pi pi-book"}
                         iconOnly={false}
                         disabled={false}
                         onClick={this.archive_Click}/>
                {!planningMember && <React.Fragment>
                    <MSpacer/>
                    <MButton label="TM Crews"
                             color="info"
                             icon={"pi pi-users"}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.crews_Click}/>
                    <MSpacer/>
                    {/*<MButton label="Day View"
                             color="info"
                             icon={"pi pi-calendar"}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.dayView_Click}/>
                    <MSpacer/>*/}
                    <MButton label="Drawings"
                             color="info"
                             icon={"pi pi-images"}
                             disabled={false}
                             onClick={this.drawings_Click}/>
                </React.Fragment>}
                {supervisor && <React.Fragment>
                    <MSpacer/>
                    <MButton label="Projects"
                             color="info"
                             icon={"pi pi-wrench"}
                             disabled={this.isProjectsDisabled}
                             onClick={() => {this.props.navigate("/projects")}}/>
                </React.Fragment>}
            </MToolbar>
        );

    }

    private dateFilterTemplate = (options: any) => {
        return <Calendar value={options.value}
                         onChange={(e: any) => options.filterApplyCallback(e.value, options.index)}
                         dateFormat="dd/mm/yy"
                         placeholder="dd/mm/yyyy"
                         mask="99/99/9999"/>;
    };

    private getProjectFilterTemplate(options: ColumnFilterElementTemplateOptions): ReactNode {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList : MDropDownItem<number>[] = (
            this.state.projectList
                .map((enumvalue) => {
                    return {label: enumvalue.code + ' - ' + enumvalue.name, value: enumvalue.id};
                })
        );

        const sessionString: string | null = localStorage.getItem(SessionDataTag);
        let selectedValues: number[] = [];
        if(sessionString) {
            const sessionData: SessionData | null = JSON.parse(sessionString)
            selectedValues = sessionData!.filters['data.projectValue'].value
        }

        return (
            <MMultiDropDown id="projectFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}
                            initialValues={selectedValues}
            />
        );
    }

    private getWorkstreamFilterTemplate(options: ColumnFilterElementTemplateOptions): ReactNode {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList : MDropDownItem<number>[] = (
            this.context.enums!.workStreams
                .map((enumvalue) => {
                    return {label: enumvalue.name, value: enumvalue.id};
                })
        );

        const sessionString: string | null = localStorage.getItem(SessionDataTag);
        let selectedValues: number[] = [];
        if(sessionString) {
            const sessionData: SessionData | null = JSON.parse(sessionString)
            selectedValues = sessionData!.filters['data.workStream'].value
        }

        return (
            <MMultiDropDown id="workstreamFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}
                            initialValues={selectedValues}
            />
        );
    }

    private getSlaFilterTemplate(options: ColumnFilterElementTemplateOptions): ReactNode {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList : MDropDownItem<number>[] = (
            this.context.enums!.slaTypes
                .map((enumvalue) => {
                    return {label: enumvalue.name, value: enumvalue.id};
                })
        );

        const sessionString: string | null = localStorage.getItem(SessionDataTag);
        let selectedValues: number[] = [];
        if(sessionString) {
            const sessionData: SessionData | null = JSON.parse(sessionString)
            selectedValues = sessionData!.filters['data.slaType'].value
        }

        return (
            <MMultiDropDown id="slaTypeFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}
                            initialValues={selectedValues}
            />
        );
    }

    private getQuoteStatusFilterTemplate(options: ColumnFilterElementTemplateOptions): ReactNode {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const quoteStatusList = this.state.table.rowData.map(q => q.quoteStatus);
        const uniqueStatuses = quoteStatusList.filter((value, index, array) => array.indexOf(value) === index);

        const itemList: MDropDownItem<string>[] = (
            uniqueStatuses
                .map((enumValue) => {
                    return {label: enumValue, value: enumValue};
                })
        );

        const sessionString: string | null = localStorage.getItem(SessionDataTag);
        let selectedValues: string[] = [];
        if(sessionString) {
            const sessionData: SessionData | null = JSON.parse(sessionString)
            selectedValues = sessionData!.filters['quoteStatus'].value
        }

        return (
            <MMultiDropDown id="quoteStatusFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: string[]) => options.filterApplyCallback(selection)}
                            initialValues={selectedValues}
            />
        );
    }

    private quoteStatusFilterCallback(value: string, filter: string[]): boolean {
        return filter.includes(value);
    }

    private getJobStatusFilterTemplate(options: ColumnFilterElementTemplateOptions): ReactNode {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.jobStatuses
                .map((enumValue) => {
                    return {label: enumValue.name, value: enumValue.id};
                })
        );

        return (
            <MMultiDropDown id="jobStatusFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    private createdDateTemplate = (rowData: RequestRow) : ReactElement => {
        try {
            let createdDate = new Date(rowData.data.submittedDate!);

            return <div>
                {createdDate.toLocaleDateString()}
            </div>
        } catch {
            return <div>{''}</div>;
        }
    }

    private dueDateTemplate = (rowData: RequestRow) : ReactElement => {
        try {
            //Add working days to the creation date to get the due Date.
            let dueDate = new Date(rowData.data.dueDate!);

            return <div>
                {dueDate.toLocaleDateString()}
            </div>
        } catch {
            return <div>{''}</div>;
        }
    }

    private completeDateTemplate = (rowData: RequestRow) : ReactElement => {
        try {
            let completeDate = new Date(rowData.data.quoteCompleteDate!);

            if(completeDate.getFullYear() < 2020) {
                return <div>{''}</div>;
            }

            return <div>
                {completeDate.toLocaleDateString()}
            </div>
        } catch {
            return <div>{''}</div>;
        }
    };

    private ragTemplate = (rowData: RequestRow) : ReactElement => {
        try {
            //Add working days to the creation date to get the due Date.
            let dueDate = new Date(rowData.data.dueDate!);

            const  checkStatuses = [3,4,5];
            const checkDate = checkStatuses.includes(rowData.data.quoteStatus) ?
                              rowData.data.quoteCompleteDate ?? new Date() :
                              new Date();
            const warningDate = new Date(dueDate);
            warningDate.setDate(warningDate.getDate() - 2);
            const ragColour : string = (checkDate > dueDate) ? 'red' : (checkDate > warningDate) ? 'darkorange' : 'green';

            return <div>
                <svg width={50}
                     height={15}
                     style={{display: 'block', margin: 'auto'}}>
                    <rect x={0}
                          y={5}
                          width={40}
                          height={10}
                          stroke={'grey'}
                          strokeWidth="1"
                          fill={ragColour}/>
                </svg>
            </div>
        } catch {
            return <div>{''}</div>;
        }
    };

    private projectTemplate = (rowData: RequestRow) => {
        const index = this.state.projectList.findIndex(value => value.id === rowData.data.projectValue);

        if(index === undefined || index === -1) {
            return null;
        }

        return <span style={{fontSize: 'x-small'}}>
            <div>{this.state.projectList[index].code}</div>
            <div>{this.state.projectList[index].name}</div>
        </span>;
    };

    private workstreamTemplate = (rowData: RequestRow) => {
        const index = this.context.enums?.workStreams.findIndex(value => value.id === rowData.data.workStream);

        if(index === undefined || index === -1) {
            return null;
        }

        return this.context.enums?.workStreams[index].name;
    };

    private quoteStatusTemplate = (rowData: RequestRow) => {
        return (<span style={{whiteSpace: 'normal', fontSize: 'small'}}>
            { rowData.quoteStatus }
        </span>);
    }

    private slaTypeTemplate = (rowData: RequestRow) => {
        const index = this.context.enums?.slaTypes.findIndex(value => value.id === rowData.data.slaType);

        if(index === undefined || index === -1) {
            return null;
        }

        return this.context.enums?.slaTypes[index].name;
    };

    private drawingsByTemplate = (rowData: RequestRow) => {
        const crewName = rowData.data.drawingsBy !== null && rowData.data.drawingsBy!.length > 0
                         ? rowData.data.drawingsBy?.join(', ')
                         : '';

        return (<span style={{whiteSpace: 'normal', fontSize: 'small'}}>
            { crewName }
        </span>);
    }

    public render(): ReactElement {
        return (
            <MPage title="TM CAD Requests"
                   locked={this.state.page.locked}
                   toolbar={this.getToolbarTemplate()}
                   onLoadData={this.page_onLoadData}
                   ref={this.m_pageRef}>

                <MessageDialog ref={this.m_messageDialogRef}/>

                <div style={{border: '1px solid', padding: '10px', margin: '5px'}} className={'infoBar'}>
                    <table style={{width: '600px'}}>
                        <colgroup>
                            <col span={1} style={{width: '25%'}}/>
                            <col span={1} style={{width: '25%'}}/>
                            <col span={1} style={{width: '25%'}}/>
                            <col span={1} style={{width: '25%'}}/>
                        </colgroup>

                        <tbody>
                            <tr>
                                <td>Complete (& NC): <b>{this.state.completeCount}</b></td>
                                <td>Unactioned: <b>{this.state.unactionedCount}</b></td>
                                <td>In Progress: <b>{this.state.inProgressCount}</b></td>
                                <td>Awaiting Info: <b>{this.state.awaitingInfoCount}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <MTable
                    innerRef={this.m_dataTableRef}
                    rowKey="data.estimate"
                    rowData={this.state.table.rowData}
                    filters={this.state.table.filters}
                    onSelectionChange={this.table_onSelectionChange}
                    sortMode={'multiple'}
                    rowsPerPage={this.state.table.rowData.length}
                    multiSortMeta={[{field: 'data.estimate', order: 1}]}
                    exportFunction={this.exportFunction}
                    exportName={'RequestsExport'}
                    stateStorage={'local'}
                    stateKey={SessionDataTag}
                >

                    <Column field="data.estimate"
                            header="Estimate"
                            filter={true}
                            sortable={true}
                            style={{width: '8%'}}/>
                    <Column field="data.locked"
                            header="Locked"
                            filter={false}
                            sortable={false}
                            body={(rowData: RequestRow) => rowData.data.locked ? 'Yes' : ''}
                            style={{width: '8%'}}/>
                    <Column field="data.requestor"
                            header="Requestor"
                            filter={true}
                            sortable={true}
                            style={{width: '8%'}}/>
                    <Column field="data.projectValue"
                            header="Project Code"
                            filter={true}
                            filterElement={this.getProjectFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.projectTemplate}
                            style={{width: '12%'}}/>
                    <Column field="data.workStream"
                            header="Work Stream"
                            filter={true}
                            filterElement={this.getWorkstreamFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.workstreamTemplate}
                            style={{width: '12%'}}/>
                    <Column field="data.county"
                            header="County"
                            filter={true}
                            sortable={true}
                            style={{width: '12%'}}/>
                    <Column field="data.postcode"
                            header="Postcode"
                            filter={true}
                            sortable={true}
                            style={{width: '10%'}}/>
                    <Column field="quoteStatus"
                            header="Quote Status"
                            filter={true}
                            filterElement={this.getQuoteStatusFilterTemplate}
                            filterMatchMode={"custom"}
                            filterFunction={this.quoteStatusFilterCallback}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.quoteStatusTemplate}
                            style={{width: '12%'}}/>
                    <Column field="data.slaType"
                            header="SLA Type"
                            filter={true}
                            filterElement={this.getSlaFilterTemplate}
                            showFilterMenu={false}
                            showClearButton={false}
                            sortable={true}
                            body={this.slaTypeTemplate}
                            style={{width: '12%'}}/>
                    <Column field="data.drawingsBy"
                            header="Drawings"
                            filter={false}
                            showFilterMenu={false}
                            showClearButton={false}
                            sortable={false}
                            body={this.drawingsByTemplate}
                            style={{width: '12%'}}/>
                    <Column field="data.drawingCount"
                            header="Count"
                            filter={false}
                            style={{width: '12%'}}/>
                    <Column header="RAG"
                            sortable={false}
                            body={this.ragTemplate}
                            style={{width: '5%'}}/>
                    <Column field="data.submittedDate"
                            header="Created Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.createdDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="data.dueDate"
                            header="Due Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.dueDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="data.quoteCompleteDate"
                            header="Completed Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.completeDateTemplate}
                            style={{width: '12%'}}/>
                </MTable>
            </MPage>
        );
    }
}

export default withMsal(WithRouter(ListRequestsPage));
